/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export function contactForm() {

  $('input').on('focus', function () {
    $(this)
      .closest('.gfield')
      .addClass('focused');
  });

  $('input').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .closest('.gfield')
        .removeClass('focused');
    }
  });

  $('textarea').on('focus', function () {
    $(this)
      .closest('.gfield')
      .addClass('focused');
  });

  $('textarea').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .closest('.gfield')
        .removeClass('focused');
    }
  });



  // let smoother = ScrollSmoother.get();

  // $('#gform_submit_button_1').on('click', function () {
  //   if (smoother) {
  //     // Store original scrollTo method
  //     const originalScrollTo = smoother.scrollTo;

  //     // Replace with a no-op function during processing
  //     smoother.scrollTo = function () { return this; };

  //     // Restore after form processes, then scroll with offset
  //     setTimeout(() => {
  //       smoother.scrollTo = originalScrollTo;

  //       // Now scroll to the confirmation with offset
  //       const confirmationElement = document.querySelector('#gform_confirmation_wrapper_1, #gform_wrapper_1');
  //       if (confirmationElement && smoother) {
  //         // Adjust this offset value (in pixels)
  //         const offset = 200; // Change this number to adjust spacing from top
  //         smoother.scrollTo(confirmationElement, true, "top " + offset + "px");
  //       }
  //     }, 1000);
  //   }
  // });



}
